import * as yup from "yup";

export const paymentMethodSchema = yup.object().shape({
  name: yup.string().required().label("Name"),
});
